import mixpanel from 'mixpanel-browser';
import posthog from 'posthog-js';

init();

function isProd() {
  return import.meta.env.PROD;
}

export function init() {
  if (isProd()) {
    mixpanel.init('6582034838776ae758df251c6fa644f3', { debug: false, track_pageview: true});
  }
}

export function identify(email, name) {
  if (isProd()) {
    mixpanel.identify(email);
    posthog.identify(email, {name: name, email: email});
  }
}

export function set_people(properties) {
  if(isProd()) {
    mixpanel.people.set(properties);
  }
}

export function set_people_once(properties) {
  if (isProd()) {
    mixpanel.people.set_once(properties);
    posthog.setPersonProperties({}, properties);
  }
}

export function track(event, properties) {
  if (isProd()) {
    posthog.capture(event, properties);
    mixpanel.track(event, properties);
  }else {
    console.log("Mixpanel Tracking:", event, properties);
  }
}

export function reset() {
  if (isProd()) {
    mixpanel.reset();
  }
}

export function trackPageView() {
  if (isProd()) {
    mixpanel.track_pageview();
  }
}
